export const assignNodeRole = (id, role) => ({
    type: "JOINT.ROLES.ASSIGN",
    payload: { id, role },
});
